import styled from 'styled-components';

export const LoadingView = styled.div`
height: 10%;
/* position: absolute; */
align-self: center;
justify-content: center;
align-items: center;
margin-left: 10%;
`;


export const LoadingErrorImg = styled.img`
height: 25%; 
width: 20%; 
object-fit: contain;
align-self:center

`;